import React from 'react'
import UserDoctor from '../../components/UserDoctor/UserDoctor'

function UserDoctorPage() {
  return (
    <UserDoctor/>
  )
}

export default UserDoctorPage